import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { useAjaxContext } from '../../../../core/ajax'
import { getFormattedTime, dataToXLS } from '../../../../core/utils'
import { feedback } from '../../../../core/feedback'
import { ThemeButton, useModalContext } from '../../../../ui'
import {
  ADMINISTRATIVE_LEAVES_TABLE_COLUMNS_KEY,
  EXPORT_LEAVES_TABLE_COLUMNS as columns,
} from '../../constants'
import { ExportNotEmptyDialog, ExportSomethingDialog } from '../dialogs'
import { administrativeLeavesDataPreparation } from '../../logics/administrative-leaves.logics'
import { useExportToXLSCalls } from '../../hooks'

export const ExportLeavesToXLSBtn = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const email = useSelector((state) => state.global.email)
  const selectedRows = useSelector((state) => state.administrativeLeaves.selectedRows)
  const search = useSelector((state) => state.administrativeLeaves.search)
  const pagination = useSelector((state) => state.administrativeLeaves.pagination)
  const combos = useSelector((state) => state.combos)
  const { get } = useAjaxContext()
  const { requestNewExportByEmail } = useExportToXLSCalls()
  const {
    actions: { open },
  } = useModalContext()

  const [loading, setLoading] = useState(false)

  const exportUrl = `bajas_administrativas/`

  const mainExport = async (data) => {
    const fileName = `clientes_con_consumo_sin_contrato_${getFormattedTime()}.xlsx`
    await dataToXLS(data, columns, combos, intl, ADMINISTRATIVE_LEAVES_TABLE_COLUMNS_KEY, fileName)
  }

  const handleExport = async () => {
    if (!selectedRows?.length) {
      open({ Component: ExportSomethingDialog })
      return
    }

    setLoading(true)
    try {
      await mainExport(selectedRows)
    } catch (error) {
      console.error('Error al exportar filas seleccionadas:', error)
      feedback('error', formatMessage({ id: 'global.error.generic' }))
    } finally {
      setLoading(false)
    }
  }

  const handleExportAll = async () => {
    const { total_registros } = pagination
    if (!total_registros) {
      open({ Component: ExportNotEmptyDialog })
      return
    }

    setLoading(true)
    try {
      const { _num_x_pagina, _pagina, ...otherSearch } = search

      if (total_registros > 500) {
        try {
          await requestNewExportByEmail(email)
          feedback(
            'info',
            formatMessage({ id: 'pages.administrativeLeaves.exportToXLS.dialogs.large.text' })
          )
        } catch (code) {
          if (code === 'already started') {
            feedback(
              'warning',
              formatMessage(
                { id: 'pages.administrativeLeaves.exportToXLS.dialogs.running.export.text' },
                { email }
              )
            )
          } else {
            feedback(
              'info',
              formatMessage({ id: 'pages.administrativeLeaves.exportToXLS.dialogs.large.text' })
            )
          }
        }
      } else {
        const { data } = await get(exportUrl, {
          params: { ...otherSearch, _num_x_pagina: total_registros, _pagina: '1' },
        })

        if (!data?.items) {
          throw new Error('No se recibieron datos válidos del servidor.')
        }

        const recievedData = administrativeLeavesDataPreparation(columns, data.items, {
          intl,
        })
        await mainExport(recievedData)
      }
    } catch (error) {
      console.error('Error durante la exportación:', error)
      const message =
        error?.response?.data?.message || formatMessage({ id: 'global.error.generic' })
      feedback('error', message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ThemeButton
        color="primary"
        labelM="sm"
        onClick={handleExport}
        style={{ marginRight: '1em' }}
        loading={loading}
        disabled={loading}
      >
        {formatMessage({ id: 'global.exportSelected' })} ({selectedRows.length})
      </ThemeButton>
      <ThemeButton
        color="primary"
        labelM="sm"
        loading={loading}
        onClick={handleExportAll}
        disabled={loading}
      >
        {formatMessage({ id: 'global.exportAll' })}
      </ThemeButton>
    </>
  )
}
